import { Typography } from '@/shared/components/ui/typography'
import React from 'react'
import { PlaybookCreationForm } from '../../playbooks/components/PlaybookCreationForm'

export const Hero: React.FC = () => {
  return (
    <section className="relative mx-auto flex max-w-full flex-col items-center self-center overflow-hidden bg-white py-16 md:min-h-[848px] md:rounded-xl md:pb-0 md:pt-[200px]">
      <div className="absolute inset-0 md:px-4">
        <div className="relative h-full overflow-hidden md:rounded-xl">
          <div
            className="absolute inset-0"
            style={{
              background:
                'linear-gradient(rgba(255,255,255,.1), rgba(255,255,255,0.1)), url(/lovable-uploads/dac3d0e0-51ff-416b-9ef9-e9f85e54d49c.jpg) 50% / cover no-repeat',
              backgroundBlendMode: 'normal, screen',
            }}
          />
        </div>
      </div>
      <div className="relative flex max-w-full flex-col items-center gap-6 rounded-xl px-6 md:w-[1148px] md:gap-8 md:px-16 md:pb-12">
        <div className="w-full text-center text-primary">
          <div className="flex w-full flex-col items-stretch gap-2 max-md:max-w-full md:gap-4">
            <Typography
              variant="h1"
              className="mx-auto max-w-xl text-center leading-[110%] text-primary"
            >
              Turn any work problem into an AI-powered solution in minutes
            </Typography>
            <Typography
              variant="subtitle"
              className="mx-auto max-w-2xl text-center text-primary"
            >
              From AI FOMO to AI Workflow — empowering teams to build, solve,
              and excel with AI-native execution.
            </Typography>
          </div>
        </div>
        <div className="w-full max-w-[800px]">
          <PlaybookCreationForm hideVisibilityControl />
        </div>
      </div>
    </section>
  )
}
